module.exports = __webpack_public_path__ + "img/row.5496e621.svg";